module.exports = __webpack_public_path__ + "static/img/1.babbb44.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/legao/1.jpg
// module id = j+6z
// module chunks = 1